import { useMemo } from 'react';
import {
  Badge,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  debounce,
} from '@mui/material';

import { Iconify } from '../iconify';

const SearchBar = ({
  sx,
  filterShown,
  onClickFilter,
  activeDebounce = true,
  onChange,
  isFilterApplied = false,
  ...rest
}) => {
  const searchDelayed = useMemo(
    () => (activeDebounce && onChange ? debounce(onChange, 300) : onChange),
    [onChange, activeDebounce]
  );

  return (
    <Stack direction="row" sx={sx} spacing={1} alignItems={'center'}>
      <TextField
        fullWidth
        size='small'
        onChange={searchDelayed}
        {...rest}
        InputProps={{
          startAdornment: (
            <InputAdornment position="end">
              <IconButton>
                <Iconify icon="eva:search-fill" />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          height: '100%',
          '.MuiOutlinedInput-root': {
            height: '100%',
            borderRadius: '10px',
            backgroundColor: 'common.grey',
          },
        }}
      />

      {filterShown && (
        <IconButton
          onClick={onClickFilter}
          sx={{
            p: 0,
            width: 40,
            height: 40,
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.common.white,
            borderRadius: 1,
            '&:hover': {
              backgroundColor: (theme) => theme.palette.primary.dark,
            },
          }}
        >
          <Badge variant="dot" color="secondary" invisible={!isFilterApplied}>
            <Stack height={25} width={25} alignItems="center" justifyContent="center">
              <Iconify icon={'uil:filter'} width={20} />
            </Stack>
          </Badge>
        </IconButton>
      )}
    </Stack>
  );
};

export default SearchBar;
